var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"highlight",rawName:"v-highlight"}],staticClass:"sspai",style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.articleHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }